import { render, staticRenderFns } from "./SearchSavedFilters.vue?vue&type=template&id=760b2ae0&"
import script from "./SearchSavedFilters.vue?vue&type=script&lang=js&"
export * from "./SearchSavedFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports